// Module
var code = "<svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"11\" cy=\"11\" r=\"10.25\" stroke-width=\"1.5\"/><path d=\"M6 10.973h10M10.973 6v10\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\"/></svg> ";
// Exports
module.exports = code;